import React from 'react';
import { PageSpinner, Stack, Text } from '@guestyci/arc';
import t from '@guestyci/localize/t.macro';

const LoginSpinner = () => {
  return (
    <Stack
      spacing={4}
      align="center"
      justify="center"
      className="gst-min-h-screen"
    >
      <PageSpinner />
      <Text size="xl" bold>
        {t('Setting up your session')}
      </Text>
    </Stack>
  );
};

export default LoginSpinner;
